@switch (pod.podType) {
    @case (podType.Single) {
        <ms-top-events-single [pod]="pod" [index]="index"></ms-top-events-single>
    }
    @case (podType.Grid) {
        <ms-top-events-grid [pod]="pod" [allowHeaderCollapse]="allowHeaderCollapse"></ms-top-events-grid>
    }
    @case (podType.Outright) {
        <ms-top-events-outrights [pod]="pod" [index]="index"></ms-top-events-outrights>
    }
    @case (podType.PropsMultiPod) {
        <ms-top-events-props-multipod [pod]="pod" [index]="index"></ms-top-events-props-multipod>
    }
    @case (podType.HandpickedOptionsPod) {
        <ms-top-events-props-handpickedoptionspod [pod]="pod" [index]="index"></ms-top-events-props-handpickedoptionspod>
    }
    @case (podType.BetBuilder) {
        <ms-top-events-betbuilder [pod]="pod" [index]="index"></ms-top-events-betbuilder>
    }
}
